export default __webpack_public_path__ + "static/media/paso27.cd5b37ca.png";